import React, { useEffect, useState } from 'react';
import Joyride from 'react-joyride';
// import { Modal } from 'react-bootstrap';

const styles = {
  eyebrow: {
    display: 'inline-block',
    marginBottom: 10,
    color: '#0d8069',
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: '1.2px',
    textTransform: 'uppercase',
  },
  introTitle: {
    margin: '0 0 9px',
    color: '#1f2d40',
    fontFamily: 'inherit',
    fontSize: 25,
    fontWeight: 750,
    letterSpacing: '-0.5px',
    lineHeight: 1.25,
  },
  introText: {
    maxWidth: 340,
    margin: '0 auto',
    color: '#69778a',
    fontSize: 14,
    lineHeight: 1.6,
  },
};

const steps = [
  {
    content: (
      <div>
        <span style={styles.eyebrow}>Quick website tour</span>
        <h2 style={styles.introTitle}>Let&apos;s begin our journey!</h2>
        <p style={styles.introText}>
          Discover the fastest way to find and customize your ideal business package.
        </p>
      </div>
    ),
    placement: 'center',
    target: 'body',
  },
  {
    target: '.tour-search',
    content: 'Search this package',
  },
  {
    target: '.tour-plus',
    content: 'customize your packages.',
  },
  {
    target: '.tour-login',
    content: 'login or register your account',
  },
  {
    target: '.tour-bestsell',
    content: 'Best Selling packages',
  },
  
  {
    target: '.tour-advance',
    content: 'advanced search here.',
  },
  {
    target: '.tour-custom',
    content: 'customize your packages.',
  },
];

export default function JoyrideProvider() {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia('(max-width: 991px)').matches);

  useEffect(() => {
    const media = window.matchMedia('(max-width: 991px)');
    const update = () => setIsMobile(media.matches);
    update();
    if (media.addEventListener) {
      media.addEventListener('change', update);
      return () => media.removeEventListener('change', update);
    }
    media.addListener(update);
    return () => media.removeListener(update);
  }, []);

  if (isMobile) return null;

  // const [open,setOpen] = useState(false);
  // const [run, setRun] = useState(false);
  return (
    <>
      <Joyride
        continuous
        run={window.location.pathname==='/'}
        // scrollToFirstStep
        // showProgress
        showSkipButton
        steps={steps}
        styles={{
          options: {
            arrowColor: '#ffffff',
            backgroundColor: '#ffffff',
            overlayColor: 'rgba(20, 31, 46, 0.58)',
            primaryColor: '#0d8069',
            textColor: '#354458',
            zIndex: 10000,
          },
          tooltip: {
            width: 420,
            padding: 24,
            border: '1px solid #e2e8ee',
            borderRadius: 18,
            boxShadow: '0 24px 70px rgba(20, 31, 46, 0.22)',
          },
          tooltipContainer: {
            lineHeight: 1.5,
            textAlign: 'left',
          },
          tooltipContent: {
            padding: '16px 8px 18px',
          },
          tooltipFooter: {
            marginTop: 4,
            paddingTop: 16,
            borderTop: '1px solid #edf1f4',
          },
          buttonNext: {
            minWidth: 88,
            padding: '10px 18px',
            borderRadius: 9,
            backgroundColor: '#0d8069',
            color: '#ffffff',
            fontSize: 13,
            fontWeight: 750,
            boxShadow: '0 6px 14px rgba(13, 128, 105, 0.2)',
          },
          buttonBack: {
            marginRight: 8,
            padding: '9px 13px',
            color: '#617083',
            fontSize: 13,
            fontWeight: 700,
          },
          buttonSkip: {
            padding: '9px 3px',
            color: '#738195',
            fontSize: 13,
            fontWeight: 700,
          },
          buttonClose: {
            top: 14,
            right: 14,
            width: 30,
            height: 30,
            padding: 8,
            border: '1px solid #e0e6ec',
            borderRadius: '50%',
            backgroundColor: '#f7f9fb',
            color: '#657386',
          },
        }}
      />
      {/* <Modal show={open}  onHide={()=>setOpen(!open)}  centered>
          <Modal.Header closeButton>  Website tour </Modal.Header>
          <Modal.Body>
            <div className='d-flex justify-content-center align-items-center' style={{minHeight:"150px"}}>
            <button className='btn btn-primary' onClick={()=>{
              setRun(true); setOpen(false)
              }} >Take a Tour</button>
            </div>
          </Modal.Body>
      </Modal> */}
    </>
  )
}
